module.exports = __webpack_public_path__ + "static/media/244-300.4b20604a.webp";